import React from "react";

import { Box } from "@chakra-ui/react";

import { Button } from "ui/button";
import { Modal } from "ui/modal";
import { ModalHeader } from "ui/modal/modal-header";
import { defaultModalCss } from "ui/modal/styles";
import { Heading3, Paragraph3 } from "ui/typography";

import { IBvnVerificationResetModalProps } from "./types";

export const BvnVerificationResetModal = (
  props: IBvnVerificationResetModalProps
) => {
  const {
    isOpen,
    setIsOpen,
    handleBvnResetSection,
    handleToggleBvnResetModal,
    isLoading,
  } = props;

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      modalCss={{
        ...defaultModalCss,
        // height: "316px",
      }}
      allowOutsideClick={false}
    >
      <ModalHeader modalType="approval" />
      <Box className="flex flex-col gap-5">
        <Box className="flex flex-col gap-2">
          <Heading3
            fontSize="18px"
            lineHeight="28px"
            textColor="#1A202C"
          >
            Reset BVN
          </Heading3>
          <Paragraph3
            lineHeight="20px"
            textColor="#475467"
          >
            Please confirm that you want to perform this action.
          </Paragraph3>
        </Box>
        <Box
          css={{
            height: "44px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <Button
            variant="outline"
            textColor="#344054"
            border="1px solid #D0D5DD"
            className="w-[170px]"
            onClick={handleToggleBvnResetModal}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="solid"
            textColor="#ffffff"
            border="1px solid #00535C"
            className="w-[170px]"
            onClick={handleBvnResetSection}
            loading={isLoading}
            loadingText="Resetting..."
            disabled={isLoading}
          >
            Reset
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
